import * as React from 'react';

export function useDebounce<T>(value: T, delay: number) {
    const [ debouncedValue, setDebouncedValue ] = React.useState(value);

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        }
    }, [ value, delay ]);

    return debouncedValue;
}